import React from 'react'

const Cards = () => {

    const posts = [
        {
            id: 1,
            title: 'Blog Title',
            href: '#',
            description:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            imageUrl:
                'https://images.unsplash.com/photo-1597892672196-3bb8b5c06171?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        },
        {
            id: 2,
            title: 'Boost your conversion rate',
            href: '#',
            description:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            imageUrl:
                'https://images.unsplash.com/photo-1580746353679-aa5dee1ac3e3?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        },
        {
            id: 3,
            title: 'Boost your Business',
            href: '#',
            description:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            imageUrl:
                'https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        },
    ]

    return (
        <>
            <div className="bg-gray-100 py-8 sm:py-10">
                <div className="mx-auto max-w-7xl px-4 lg:px-4 ">
                    <div className="relative">
                        {/* Full-width featured image */}
                        <img
                            className="w-full h-96 object-cover"
                            src="https://images.unsplash.com/photo-1614270248176-3fdd040ac6e7?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                            alt="Featured"
                        />

                        {/* Overlay with text */}
                        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50"></div>

                        {/* Text on top of the image */}
                        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-white">
                            <h1 className="text-4xl font-bold mb-4">Blogs</h1>
                            <p className="text-base lg:text-lg">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                        </div>
                    </div>

                    <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t-2 border-gray-200 pt-8 sm:mt-12 sm:pt-12 lg:mx-0 lg:max-w-none lg:grid-cols-3 ">
                        {posts.map((post) => (
                            <div className="max-w-sm rounded overflow-hidden shadow-lg m-4">
                                <img
                                    className="w-full h-48 object-cover object-top"
                                    src={post.imageUrl}
                                    alt="Blog Post"
                                />
                                <div className="px-6 py-4">
                                    <div className="font-bold text-xl mb-2">{post.title}</div>
                                    <p className="text-gray-700 text-base">
                                        {post.description}
                                    </p>
                                </div>
                                <div className="px-6 py-4">
                                    <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2">#Tag1</span>
                                    <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2">#Tag2</span>
                                    <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700">#Tag3</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Cards